// @ts-nocheck
export const checkIsCluster = ({ properties }) => !!properties.cluster;
